import axios from "axios";

// console.log('helperFunc::', JSON.parse(localStorage.getItem('token')))

var country = localStorage.getItem('country') ? JSON.parse(localStorage.getItem('country'))._id : 'all';
var userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).id : '';
var header = localStorage.getItem('token') ? { 'x-access-token': JSON.parse(localStorage.getItem('token')), country: country, 'company-code': 'NW', 'user-id': userId } : { country: 'all', 'company-code': 'NW', 'user-id': userId };
// var header = localStorage.getItem('token') ? { 'x-access-token': JSON.parse(localStorage.getItem('token')), country: country, 'company-code': 'NW' } : { country: 'all', 'company-code': 'NW' };


const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 3000000000,
    headers: header
});
instance.interceptors.request.use(function (config) {
    if (!!config.data) {
        for (let key of Object.keys(config?.data)) {
            if (config.data[key] === "" || config.data[key] === undefined)
                config.data[key] = null
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.status === 200) {
        return response.data;
    }
    if (response.status === 205) {
        localStorage.setItem("refresh",true);
        // setTimeout(() => {
            window.location.reload();
        // }, 1000);
        return response;
    }
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.log('error::', error.response.status);
    if (error?.response?.status === 401) {
        // localStorage.removeItem("token");
        // localStorage.removeItem("username");
        // localStorage.removeItem("userData");
        // localStorage.removeItem("country");
        // localStorage.removeItem("persist:v726-demo1-auth");
       // window.location.reload();
        setTimeout(() => {
            localStorage.clear();
            window.location.reload();
        }, 1000);
    }
    
    // console.log('error------------------>:', error)
    return Promise.reject(error);
});

export default instance;

var header2 = { country: 'all', 'company-code': 'NW', 'user-id': userId };

export const instanceTokenLess = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 3000000000,
    headers: header2
});
instanceTokenLess.interceptors.request.use(function (config) {
    if (!!config.data) {
        for (let key of Object.keys(config?.data)) {
            if (config.data[key] === "" || config.data[key] === undefined)
                config.data[key] = null
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
instanceTokenLess.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.status === 200) {
        return response.data;
    }
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.log('error::', error.response.status);
    if (error?.response?.status === 401) {
        // localStorage.removeItem("token");
        // localStorage.removeItem("username");
        // localStorage.removeItem("userData");
        // localStorage.removeItem("country");
        // localStorage.removeItem("persist:v726-demo1-auth");
      //  window.location.reload();
    }
    console.log('error------------------>:', error)
    return Promise.reject(error);
});

// export  instanceTokenLess;